<template>
    <rkm-area
        type="fieldset"
        title="Residência"
    >

        <rkm-row v-if="data.model">
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.imovelTipo"
                    textField="descricao"
                    valueField="id"
                    label="Tipo do imóvel"
                    v-model="data.model.residencia.imovelTipoId"
                    default-option-text="Selecione"
                    show-default-option
                    :validations="validations.imovelTipo"
                    @change="handleImovelTipo"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.situacaoDomicilio"
                    textField="descricao"
                    valueField="id"
                    label="Situação"
                    v-model="data.model.residencia.situacaoDomicilioId"
                    default-option-text="Selecione"
                    show-default-option
                    :validations="validations.situacaoDomicilio"
                    :disabled="isDisabled()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.zonas"
                    textField="descricao"
                    valueField="id"
                    label="Zona"
                    v-model="data.model.residencia.domicilioZonaId"
                    default-option-text="Selecione"
                    show-default-option
                    :validations=validations.zonaDomicilio
                    @change="handleZonaTipo"
                    :disabled="isTipoDisabled()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.domicilioTipo"
                    textField="descricao"
                    valueField="id"
                    label="Tipo de domicílio"
                    v-model="data.model.residencia.domicilioTipoId"
                    default-option-text="Selecione"
                    show-default-option
                    :disabled="isDisabled()"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    v-model="data.model.residencia.moradores"
                    label="Moradores"
                    number
                    :validations="validations.moradores"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    v-model="data.model.residencia.quantidadeComodos"
                    label="Cômodos"
                    number
                    :validations="validations.comodos"
                    :disabled="isDisabled()"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.situacaoRural"
                    textField="descricao"
                    valueField="id"
                    label="Situação rural"
                    v-model="data.model.residencia.situacaoRuralId"
                    default-option-text="Selecione"
                    show-default-option
                    :validations="validations.situacaoRural"
                    :disabled="data.model.residencia.domicilioZonaId != this.enums.zonaDomicilio.RURAL
                        || this.data.model.recusaCadastro"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.domicilioTipoAcesso"
                    textField="descricao"
                    valueField="id"
                    label="Tipo de acesso ao domicílio"
                    v-model="data.model.residencia.domicilioTipoAcessoId"
                    default-option-text="Selecione"
                    show-default-option
                    :disabled="isDisabled()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.materialPredominante"
                    textField="descricao"
                    valueField="id"
                    label="Material predominante - paredes externas"
                    v-model="data.model.residencia.materialPredominanteId"
                    default-option-text="Selecione"
                    show-default-option
                    :disabled="isDisabled()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-radio-group
                    v-model="data.model.residencia.energiaEletrica"
                    label="Disponibilidade de energia elétrica"
                    :disabled="isTipoDisabled()"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.abastecimento"
                    textField="descricao"
                    valueField="id"
                    label="Abastecimento de água"
                    v-model="data.model.residencia.abastecimentoId"
                    default-option-text="Selecione"
                    show-default-option
                    :disabled="isTipoDisabled()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.tratamento"
                    textField="descricao"
                    valueField="id"
                    label="Tratamento de água"
                    v-model="data.model.residencia.tratamentoId"
                    default-option-text="Selecione"
                    show-default-option
                    :disabled="isTipoDisabled()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="data.form.destinoLixo"
                    textField="descricao"
                    valueField="id"
                    label="Destino do lixo"
                    v-model="data.model.residencia.destinoLixoId"
                    default-option-text="Selecione"
                    show-default-option
                    :disabled="isTipoDisabled()"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.formaEscoamento"
                    textField="descricao"
                    valueField="id"
                    label="Forma de escoamento sanitário"
                    v-model="data.model.residencia.formaEscoamentoId"
                    default-option-text="Selecione"
                    show-default-option
                    :disabled="isTipoDisabled()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-radio-group
                    v-model="data.model.residencia.possuiAnimais"
                    label="Possui animais?"
                    :disabled="isDisabled()"
                    @change="handleAnimais"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-checkbox-group
                    :options="data.form.animais"
                    label="Quais"
                    class="mx-2"
                    name="lazer"
                    text-field="descricao"
                    v-model="data.model.residencia.animal"
                    value-field="id"
                    :disabled="data.model.residencia.imovelTipoId != this.enums.tipoImovel.DOMICILIO
                        || !data.model.residencia.possuiAnimais || this.data.model.recusaCadastro"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.residencia.quantidadeAnimais"
                    label="Quantidade"
                    number
                    :validations="validations.quantidadeAnimais"
                    :disabled="data.model.residencia.imovelTipoId != this.enums.tipoImovel.DOMICILIO
                        || !data.model.residencia.possuiAnimais || this.data.model.recusaCadastro"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Mixins
import { importacaoCns, object } from '@/mixins'

//Enums
import tipoImovel from '@/enums/atencao-basica/cadastro-domiciliar/tipoImovel'
import zonaDomicilio from '@/enums/atencao-basica/cadastro-domiciliar/zonaDomicilio'

export default {
    data: () => ({
        enums: {
            tipoImovel,
            zonaDomicilio
        },
        instituicao: {
            nome: '',
            outrosProfissionais: null,
            nomeResponsavelTecnico: '',
            cnsResponsavelTecnico: '',
            cargoResponsavelTecnico: '',
            telefoneResponsavelTecnico: ''
        },
        residencia: {
            situacaoDomicilioId: null,
            domicilioZonaId: null,
            domicilioTipoId: null,
            moradores: '',
            quantidadeComodos: '',
            situacaoRuralId: null,
            domicilioTipoAcessoId: null,
            materialPredominanteId: null,
            energiaEletrica: null,
            abastecimentoId: null,
            tratamentoId: null,
            destinoLixoId: null,
            formaEscoamentoId: null,
            possuiAnimais: null,
            animal: [],
            quantidadeAnimais: ''
        }
    }),
    computed: {
        validations() {
            return {
                imovelTipo: {
                    required: true
                },
                situacaoDomicilio: {
                    required: this.data.model.residencia.imovelTipoId == this.enums.tipoImovel.DOMICILIO
                },
                situacaoRural: {
                    required: this.data.model.residencia.domicilioZonaId == this.enums.zonaDomicilio.RURAL
                },
                zonaDomicilio: {
                    required: true
                },
                moradores: {
                    max: 4
                },
                comodos: {
                    max: 2
                },
                quantidadeAnimais: {
                    max: 2
                },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
    },
    methods: {
        handleImovelTipo() {

            const imovelTipoId = this.data.model.residencia.imovelTipoId
            const tiposImovel = [
                this.enums.tipoImovel.ABRIGO,
                this.enums.tipoImovel.INSTITUICAO_DE_LONGA_PERMANENCIA_PARA_IDOSOS,
                this.enums.tipoImovel.UNIDADE_PRISIONAL,
                this.enums.tipoImovel.UNIDADE_DE_MEDIDA_SOCIO_EDUCATIVA,
                this.enums.tipoImovel.DELEGACIA
            ]

            if (tiposImovel.includes(imovelTipoId)) {

                Object.keys(this.instituicao).forEach((key) => {
                    this.data.model.instituicao[key] = this.instituicao[key];
                });
            }

            if (imovelTipoId != this.enums.tipoImovel.DOMICILIO) {

                Object.keys(this.residencia).forEach((key) => {
                    this.data.model.residencia[key] = this.residencia[key];
                });
            }
        },
        handleZonaTipo() {

            if (this.data.model.residencia.domicilioZonaId != this.enums.zonaDomicilio.RURAL) {
                this.data.model.residencia.situacaoRuralId = null
            }
        },
        handleAnimais() {

            if (!this.data.model.residencia.possuiAnimais) {
                this.data.model.residencia.animais = []
                this.data.model.residencia.quantidadeAnimais = ''
            }
        },
        isDisabled() {

            return this.data.model.residencia.imovelTipoId != this.enums.tipoImovel.DOMICILIO
                || this.data.model.recusaCadastro
        },
        isTipoDisabled() {

            const recusa = this.data.model.recusaCadastro
            const imovelTipoId = this.data.model.residencia.imovelTipoId
            const tiposImovel = [
                this.enums.tipoImovel.ABRIGO,
                this.enums.tipoImovel.DOMICILIO,
                this.enums.tipoImovel.INSTITUICAO_DE_LONGA_PERMANENCIA_PARA_IDOSOS,
                this.enums.tipoImovel.UNIDADE_PRISIONAL,
                this.enums.tipoImovel.UNIDADE_DE_MEDIDA_SOCIO_EDUCATIVA,
                this.enums.tipoImovel.DELEGACIA
            ]

            return !recusa && tiposImovel.includes(imovelTipoId) ? false : true
        }
    },
    mixins: [ importacaoCns, object ],
    props: {
        data: { type: Object, required: false, },
    }
}
</script>